var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9666 6.44747C14.3519 6.0517 14.3433 5.41859 13.9475 5.03339C13.5517 4.64819 12.9186 4.65675 12.5334 5.05253L9.2737 8.4017L7.8755 7.28086C7.44459 6.93543 6.81522 7.00472 6.46979 7.43564C6.12435 7.86656 6.19365 8.49592 6.62457 8.84136L9.08571 10.8143C9.28666 10.9754 9.57711 10.9575 9.75675 10.7729L13.9666 6.44747Z",
    fill: "#11294C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 1.34315 1.34315 0 3 0H17C18.6569 0 20 1.34315 20 3V13C20 14.6569 18.6569 16 17 16H3C1.34315 16 0 14.6569 0 13V3ZM16.1707 2H17C17.5523 2 18 2.44771 18 3V3.82929C17.1476 3.52801 16.472 2.85241 16.1707 2ZM14.1 2H5.89998C5.5023 3.95913 3.95913 5.5023 2 5.89998V10.1C3.95913 10.4977 5.5023 12.0409 5.89998 14H14.1C14.4977 12.0409 16.0409 10.4977 18 10.1V5.89998C16.0409 5.5023 14.4977 3.95913 14.1 2ZM18 12.1707C17.1476 12.472 16.472 13.1476 16.1707 14H17C17.5523 14 18 13.5523 18 13V12.1707ZM3.82929 14C3.52801 13.1476 2.85241 12.472 2 12.1707V13C2 13.5523 2.44772 14 3 14H3.82929ZM2 3.82929C2.85241 3.52801 3.52801 2.85241 3.82929 2H3C2.44772 2 2 2.44772 2 3V3.82929Z",
    fill: "#11294C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.96a33df5d65737c7cd8a4270518d7315.svg";
export { ForwardRef as ReactComponent };